import { Field } from 'signer-app/types/editor-types';

/**
 * Finds the next field with a validation error, searching forward from the
 * current active field and wrapping around.
 *
 * Extracted from handleFieldsUnfilled in next-button.tsx so it can be
 * unit-tested independently.
 *
 * When groupAware is false (legacy), requires both f.required and a
 * validation error — misses grouped checkbox/radio fields where
 * required is false but the group has a validation error (Bug 2).
 *
 * When groupAware is true, checks for a validation error on any
 * non-read-only field, which correctly finds grouped fields while
 * skipping other signers' read-only groups.
 */
export function findNextFieldWithError(
  fields: Field[],
  activeFieldId: string | undefined,
  validationErrors: Record<string, { message: string }>,
  options: { groupAware: boolean } = { groupAware: false },
): Field | undefined {
  const i = fields.findIndex((f) => f.id === activeFieldId);
  return fields
    .concat(fields)
    .slice(i + 1)
    .find((f) => {
      if (options.groupAware) return !f.readOnly && !!validationErrors[f.id];
      return f.required && !!validationErrors[f.id];
    });
}
